import { render } from "./App.vue?vue&type=template&id=a8150eae"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a8150eae&lang=css"

import exportComponent from "/home/runner/work/BNRY-technical-assessment/BNRY-technical-assessment/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__